// extracted by css-extract-rspack-plugin
export default {"columnError":"columnError-RNmK1M","columnErrorTitle":"columnErrorTitle-j3NV8Y","columnErrorMessage":"columnErrorMessage-DQ140G"};